import { Injectable } from '@angular/core';

import { AbstractRequestFormAdaptor } from '../../form/abstract-request-form.adaptor';

@Injectable()
export abstract class AbstractRegisterAdaptor<FormData, Res> extends AbstractRequestFormAdaptor<FormData, Res> {
  override name = 'register';
}
